import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { AttendanceCustomTimeRangeDayEnum } from 'generated/resources/datatable.graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import SpecialHourWizard from 'modules/attendance/components/CustomTimeRanges/Content/Table/Modals/SpecialHourWizard'

interface HoverContentProps {
  dayType: AttendanceCustomTimeRangeDayEnum
  setIsAddingNewBlock: (show: boolean) => void
  isAddingNewBlock: boolean
}

const HoverButton = ({ dayType, isAddingNewBlock, setIsAddingNewBlock }: HoverContentProps) => {
  const onClick = () => {
    track(trackingEvents.timeTracking.specialHoursTableAddPressed)
    setIsAddingNewBlock(true)
  }

  return (
    <Box
      background="grey200"
      alignItems="center"
      justifyContent="center"
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
      height="s120"
      width="full"
    >
      <Button type="secondary" onClick={onClick} iconName="add">
        {i18n.t('common.add')}
      </Button>
      {isAddingNewBlock && (
        <SpecialHourWizard dayType={dayType} onClose={() => setIsAddingNewBlock(false)} />
      )}
    </Box>
  )
}

export default HoverButton
